<div class="app">
  <mat-toolbar color="primary" class="main-toolbar">
    <div class="spacer pointer">
      <div class="img-container" routerLink="/tours">
        <img src="assets/logo.png" alt="Logo" class="logo">
      </div>
      <span i18n routerLink="/tours">Audio Tour Museum Thorn</span>
    </div>
    <div class="spacer">
      <button mat-button *ngIf="(languageService.currentLang$ |async) !== null"
              (click)="languageService.currentLang$.next(null)">
        {{ languageService.currentLang$ | async | uppercase }}
      </button>

      <ng-container *ngIf="(user$ | async) !== null">
        <ng-container *appRoleBasedDisplay="'admin'">
          <button mat-button routerLink="/tours" routerLinkActive="/tours" i18n>Overview</button>
          <button mat-button routerLink="/tours/add" routerLinkActive="/tours/add" i18n>Create</button>
        </ng-container>
        <button mat-button (click)="logOut()" i18n>Logout</button>
      </ng-container>
      <ng-container *ngIf="(user$ | async) === null">
        <button mat-button class="hide-mobile" i18n (click)="loginWithGoogle()">Login</button>
      </ng-container>
    </div>
  </mat-toolbar>

  <div class="container">
    <router-outlet *ngIf="(languageService.currentLang$ | async) !== null; else langSwitchPage"></router-outlet>
  </div>

  <mat-toolbar class="navigation-bar" [class.tourActive]="activeTour$ | async">
    <button *ngIf="activeTour$ | async as currentTour" mat-raised-button (click)="previousStep()" i18n
            [disabled]="currentTour.step - 1 === 0">
      Previous
    </button>


    <div class="spacer">
      <!--    <button mat-raised-button routerLink="/tours">-->
      <!--      Finish-->
      <!--    </button>-->
      <button mat-icon-button (click)="openNumberDial()">
        <mat-icon>dialpad</mat-icon>
      </button>
    </div>

    <button *ngIf="activeTour$ | async" mat-raised-button (click)="nextStep()" [disabled]="nextTourStep === null" i18n>
      Next
    </button>
  </mat-toolbar>
</div>

<ng-template #langSwitchPage>
  <app-language-select-page></app-language-select-page>
</ng-template>
